<sc-lateral-drawer-light-box
  class="overlay"
  [class.show]="isOpen$ | async"
  (close)="onClose()">
  <sc-lateral-drawer (close)="onClose()" [isOpen]="isOpen$ | async">
    <ng-template scLateralMenuContent></ng-template>
  </sc-lateral-drawer>
</sc-lateral-drawer-light-box>